import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/base.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-datepicker/dist/react-datepicker.css";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css';
// SP8 (R407): the STARS vendor layer and shell rules load after every library's CSS so they win.
import "./styles/vendor.css";
import "./styles/shell.css";
import { mountStarsIcons } from "./styles/stars-icons";
import { SnackbarProvider } from "notistack";
import { Provider } from 'react-redux';
import store from "./redux/store";
// SEC-027/#72: registers the expiry-detection and refresh interceptors once,
// for their side effect, before the app's first API call can go out.
import "./shared/_helpers/sessionRefresh";

// SP8 (R403): one icon sprite for the whole app; StarsIcon renders <use href="#i-…">.
mountStarsIcons();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <SnackbarProvider maxSnack={1}>
      <App />
    </SnackbarProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
